/** Layouts */
import BaseLayout from '@/views/crm/mission_tache/tache/layouts/BaseLayout';
import EditLayout from '@/views/crm/mission_tache/tache/layouts/EditLayout';
import ShowLayout from '@/views/crm/mission_tache/tache/layouts/ShowLayout';

import Taches from '@/views/crm/mission_tache/tache/components/tache/List';
import Create from '@/views/crm/mission_tache/tache/components/tache/Create';
import Show from '@/views/crm/mission_tache/tache/components/tache/Show';
import Edit from '@/views/crm/mission_tache/tache/components/tache/Edit';
import Document from '@/views/fichier/pages/Fichier';
import Note from '@/views/crm/mission_tache/tache/components/note/Note';
import CompteRendu from '@/views/crm/mission_tache/tache/components/compte_rendu/CompteRendu';

export default [
  {
    path: '/crm/mission-tache/tache',
    component: BaseLayout,
    children: [
      {
        path: '',
        component: Taches,
        name: 'crm_tache',
        meta: {
          auth: true,
          module: 'crm',
          pertache: 'view tache',
        },
      },
      {
        path: 'create/:id',
        name: 'crm_tache-create',
        component: Create,
        meta: {
          auth: true,
          module: 'crm',
          pertache: 'create tache',
        },
      },

      {
        path: 'show/:id',
        component: ShowLayout,
        children: [
          {
            path: '',
            name: 'crm_tache-show',
            component: Show,
            meta: {
              auth: true,
              module: 'crm',
              pertache: 'view tache',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'crm_tache_show-document',
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
          {
            path: 'note',
            name: 'crm_tache_show-note',
            component: Note,
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
          {
            path: 'compte-rendu',
            name: 'crm_tache_show-compte-rendu',
            component: CompteRendu,
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
        ],
      },
      {
        path: 'edit/:id',
        component: EditLayout,
        children: [
          {
            path: '',
            name: 'crm_tache-edit',
            component: Edit,
            meta: {
              auth: true,
              module: 'crm',
              pertache: 'view tache',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'crm_tache_edit-document',
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
          {
            path: 'note',
            name: 'crm_tache_edit-note',
            component: Note,
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
          {
            path: 'compte-rendu',
            name: 'crm_tache_edit-compte-rendu',
            component: CompteRendu,
            meta: {
              auth: true,
              module: 'crm',
              permission: 'view tache',
            },
          },
        ],
      },
    ],
  },
];
